import { TImageStore } from '@monorepo/types';
import produce from 'immer';
import { INITIAL_CACHE_RESET_TIMESTAMP } from '../metadata/metadata.reducer';
import { InputAppImageDBActionTypes, TInputAppImageDBActions } from './image-db.actions';

export function getInitialImageStore(nextCacheResetTimestamp: number) {
  const inputAppInitialState: TImageStore = {
    imagesBucketDB: {
      nextCacheResetTimestamp,
      imageBuckets: {
        list: [],
      },
    },
    imagesBucketDBLockDetails: {
      isLocked: false,
      lockedBy: 'NONE',
    },
    imagesBucketMetadataDBLockedDetails: {
      isLocked: false,
      lockedBy: 'NONE',
    },
    serverImagesBucketMetadataDBLockedDetails: {
      isLocked: false,
      lockedBy: 'NONE',
    },
    imagesBucketMetadataDB: {
      nextCacheResetTimestamp,
      bucketsInfo: {},
    },
    serverImagesBucketDB: {
      nextCacheResetTimestamp,
      imageBuckets: {
        list: [],
      },
    },
  };
  return inputAppInitialState;
}

export function InputAppImageDBStateReducer(
  state: TImageStore = getInitialImageStore(INITIAL_CACHE_RESET_TIMESTAMP),
  action: TInputAppImageDBActions,
): TImageStore {
  switch (action.type) {
    case InputAppImageDBActionTypes.UpdateImageDBLockDetails: {
      return produce(state, (draft) => {
        draft.imagesBucketDBLockDetails = action.lockDetails;
      });
    }
    case InputAppImageDBActionTypes.UpdateSyncedImagesBucketDBLockDetails: {
      return produce(state, (draft) => {
        draft.imagesBucketMetadataDBLockedDetails = action.lockDetails;
      });
    }
    case InputAppImageDBActionTypes.UpdateServerImagesBucketDBLockDetails: {
      return produce(state, (draft) => {
        draft.serverImagesBucketMetadataDBLockedDetails = action.lockDetails;
      });
    }
    case InputAppImageDBActionTypes.ReleaseImageDBLockAndImageMetadataDBLock: {
      return produce(state, (draft) => {
        draft.imagesBucketDBLockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
        draft.imagesBucketMetadataDBLockedDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case InputAppImageDBActionTypes.ReleaseImageDBLock: {
      return produce(state, (draft) => {
        draft.imagesBucketDBLockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case InputAppImageDBActionTypes.ReleaseImageMetadataDBLock: {
      return produce(state, (draft) => {
        draft.imagesBucketMetadataDBLockedDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case InputAppImageDBActionTypes.UpdateImagesBucketDBAndReleaseLock: {
      return produce(state, (draft) => {
        draft.imagesBucketDB = action.imagesBucketDB;
        draft.imagesBucketDBLockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case InputAppImageDBActionTypes.UpdateImagesBucketMetadataDBAndReleaseLock: {
      return produce(state, (draft) => {
        draft.imagesBucketMetadataDB = action.imagesBucketMetadataDB;
        draft.imagesBucketMetadataDBLockedDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case InputAppImageDBActionTypes.UpdateImagesStoreAllDBsAndReleaseAllLocks: {
      return produce(state, (draft) => {
        draft.imagesBucketMetadataDB = action.imagesBucketMetadataDB;
        draft.imagesBucketMetadataDBLockedDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
        draft.imagesBucketDB = action.imagesBucketDB;
        draft.imagesBucketDBLockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
        draft.serverImagesBucketDB = action.severImagesBucketDB;
        draft.serverImagesBucketMetadataDBLockedDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case InputAppImageDBActionTypes.UpdateServerImagesBucketDBAndReleaseLock: {
      return produce(state, (draft) => {
        draft.serverImagesBucketDB = action.serverImagesBucketDB;
        draft.serverImagesBucketMetadataDBLockedDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    default:
      return state;
  }
}
